// this classname is used to load trustpilot frontend-side, don't change it!
// it lives in its own file to ensure we don't load useless data frontend side, as te treeshaking doesn't work as expected
export const TRUSTPILOT_WIDGET_CLASS = "trustpilot-widget";
